
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiElectricMotor as ObiElectricMotorElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-electric-motor.js';
 
 
 

 
 export const ObiElectricMotor = createComponent({
   react: React,
   tagName: 'obi-electric-motor',
   elementClass: ObiElectricMotorElement,
   events: {
     
   }
  });
 
 